export default __webpack_public_path__ + "static/media/visualstudio-code.98238ff4.png";